export default "__VITE_ASSET__B__XxF6s__"